import { render, staticRenderFns } from "./AdminMenuDrawer.vue?vue&type=template&id=3d222e4e&scoped=true&"
import script from "./AdminMenuDrawer.vue?vue&type=script&lang=js&"
export * from "./AdminMenuDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenuDrawer.vue?vue&type=style&index=0&id=3d222e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d222e4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemContent})
